import { Col, Container, Nav, Navbar, Row, Tabs } from "react-bootstrap";
import Carousel from 'react-bootstrap/Carousel';
import carrouselPais from '../../assets/aba/CarrosuelInicioPais.png'
import carrouselPeregrino from '../../assets/aba/peregrinoVariedades.png'
import carrouselFabrica from '../../assets/aba/fabricaCarrouselInicio.png'
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import logo from '../../assets/aba/logo-aba.png'
import logoPeregrino from '../../assets/logos/peregrino.png'
import goldenGin from '../../assets/peregrino/golden.jpg'
import goldenGin2 from '../../assets/peregrino/golden1-1.jpg'
import goldenGin3 from '../../assets/peregrino/golden1-3.jpg'
import pinkGin1 from '../../assets/peregrino/pink.jpg'
import pinkGin2 from '../../assets/peregrino/pink1.1.jpg'
import blackGin1 from '../../assets/peregrino/black.jpg'
import blackGin2 from '../../assets/peregrino/black1.2.jpg'
import instagram from '../../assets/logos/instagram.png'
import botanicos from '../../assets/peregrino/Peregrino-Botanicos-1.jpg'
import tipografiaGolden from '../../assets/peregrino/Tipografia_the_golden.png'
import tipografiaPink from '../../assets/peregrino/TIPOGRAFIA_THE_PINK.png'
import tipografiaBlack from '../../assets/peregrino/TIPOGRAFIA_THE_BLACK.png'
import fabrica from '../../assets/peregrino/fabrica.gif';
import sunset6 from '../../assets/peregrino/Sunset6.jpg';
import sunset7 from '../../assets/peregrino/Sunset7.jpg';
import sunset8 from '../../assets/peregrino/Sunset8.jpg';
import ginTonic from '../../assets/cocktails/ginTonic.jpg'
import ginFizz from '../../assets/cocktails/GinFizz.jpg';
import lemonGin from '../../assets/cocktails/LemonGin.jpg';

import { Tab } from "bootstrap";
import { Link } from "react-router-dom";

import videoFabrica from '../../assets/peregrino/FabricaPeregrino.mp4';
 
import ReactPlayer from 'react-player';


import { useTranslation } from 'react-i18next';

import flagEsp from '../../assets/logos/espana.png';
import flagUsa from '../../assets/logos/estados-unidos.png';
import flagChina from '../../assets/logos/china.png';

import '../Peregrino/MainPeregrino.css';

//

const block1 = {
    backgroundColor: 'violet',
    fontSize: '25px',
};

const block2 = {
    backgroundColor: '#030304',
    fontSize: '20px',
    textAlign: 'center',
};

const block3 = {
    color: 'white',
    fontSize: '30px',
    textAlign: 'center',
    marginTop: '40px',
    alignContent: 'space-evenly',
};

const blockRedes = {
    color: 'white',
    fontSize: '15px',
    textAlign: 'center',
    marginTop: '40px',
    alignContent: 'space-evenly',
};



const block4 = {
    fontSize: '1rem',
    marginTop: '15px',
    alignContent: 'center', 
    color:'white',
    borderRadius: '40px',
    textAlign: 'justify'
};

const block5 = {
    fontSize: '20px',
    marginTop: '20px',
    color: 'white', 
    textAlign: 'center'
};

const block6 = {
    backgroundColor: '#2F4666',
    fontSize: '20px',
};

const block7 = {
    marginTop: '50px',
    textAlign: 'center'
};

const texts = {
    color: 'white', 
    backgroundColor: '#623037',
    fontSize: '10px'
}

const textsBlack = {
    color: 'white', 
    backgroundColor: 'black',
    fontSize: '8px'
}

const textsGolden = {
    color: 'black', 
    backgroundColor: '#E7DEA7',
    fontSize: '8px',
    textAlign: 'justify'
}

const textsPink = {
    color: 'white', 
    backgroundColor: '#623037',
    fontSize: '8px', 
    textAlign: 'justify'
}

const textsEscritorio = {
    color: 'black', 
    backgroundColor: '#E7DEA7',
    marginTop:'20px',
    fontSize: '1rem',
    textAlign: 'justify'
}

const textsEscritorioBlack = {
    color: 'black', 
    backgroundColor: 'white',
    marginTop:'20px',
    fontSize: '1rem',
    textAlign: 'justify'
}

const textsEscritorioPink = {
    color: 'white', 
    backgroundColor: '#623037',
    marginTop:'20px',
    fontSize: '1rem', 
    textAlign: 'justify'
}

const blockCard = {
    backgroundColor: '#E7DEA7',
    fontSize: '100px',
    textAlign: 'center',
    marginTop: '120px',
    color: 'white',
    alignContent: 'center'
}

const blockCardPink = {
    backgroundColor: '#623037',
    fontSize: '4rem',
    textAlign: 'center',
    marginTop: '120px',
    color: 'white',
    alignContent: 'center'
}

const blockCardBlack = {
    backgroundColor: 'white',
    fontSize: '2rem',
    textAlign: 'center',
    marginTop: '120px',
    color: 'black',
    alignContent: 'center'
}

const blockCardBlackMobile = {
    backgroundColor: 'black',
    fontSize: '1rem',
    textAlign: 'center',
    color: 'white'
}



const blockPink = {
    backgroundColor: '#030304',
    fontSize: '20px',
    textAlign: 'center',
};


const blockBlack = {
    backgroundColor: 'black',
    fontSize: '20px',
    textAlign: 'center',
};

const styleNav = {
    textAlign: 'center'
};

function MainPeregrino() {

    const { i18n, t } = useTranslation();
        
    return (
        <Container style={block6} fluid>
            <Row>
                {/* <Navbar expand="lg" className="nav-flotante">
                    <Container>
                            <Navbar.Brand href="/">
                                <img
                                    src={logoPeregrino}
                                    width="250"
                                    height="80"
                                    className="d-inline-block align-top"
                                    alt="Aba logo"
                                />
                            </Navbar.Brand>
                            <Nav className="ml-auto" style={styleNav}>
                                <Nav.Link href="/peregrino/#pruebas" className="item-flotante">{t('peregrinoSection3Title')} </Nav.Link> 
                                <Nav.Link href="/productFamily">{t('OurBrands')}</Nav.Link> 
                                <Nav.Link href="/ecologicalCommitment">{t('EcoSustainableCommitment')}</Nav.Link>
                                <Nav.Link href="/madeForYou">{t('MadeForYou')}</Nav.Link>
                            </Nav>
                    </Container>
                </Navbar> */}
                <Navbar expand="lg" className="bg-body-white">
                    <Container>
                        <Navbar.Brand href="/">
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ms-auto" style={styleNav}>
                            <Navbar.Brand onClick={() => {i18n.changeLanguage('es')}} style={{color: 'white'}}>
                                    <img
                                        alt=""
                                        src={flagEsp}
                                        width="30"
                                        height="30"
                                        className="d-inline-block align-top"
                                    />{' '}
                                    ESP
                                    </Navbar.Brand> 
                                    <Navbar.Brand onClick={() => {i18n.changeLanguage('en')}} style={{color: 'white'}}>
                                    <img
                                        alt=""
                                        src={flagUsa}
                                        width="30"
                                        height="30"
                                        className="d-inline-block align-top"
                                    />{' '}
                                    ENG
                                    </Navbar.Brand> 
                                    <Navbar.Brand onClick={() => {i18n.changeLanguage('zh')}} style={{color: 'white'}}>
                                    <img
                                        alt=""
                                        src={flagChina}
                                        width="30"
                                        height="30"
                                        className="d-inline-block align-top"
                                    />{' '}
                                    ZH
                                    </Navbar.Brand> 
                            </Nav>

                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </Row>
            <Row>
                <Col xs={1} md={1}></Col>
                <Col xs={12} md={10} style={block7}>
                    <img
                        src={logoPeregrino}
                        width="80%"
                        height="90%"
                        className="d-inline-block align-top"
                        alt="Aba logo"
                    />
                </Col>
                <Col xs={1} md={1}></Col>
                <Row>
                    <Col xs={8} md={6} style={blockRedes}>
                        {t('FollowUsOnOurNetworks')}
                    </Col>
                    <Col md={8} xs={2} style={{height: '30px', width:'60px', marginTop: '40px'}}>
                    <Link to='https://www.instagram.com/ginperegrino.ar/'>
                        <img
                                src={instagram}
                                width="100%"
                                height="100%"
                                className="d-inline-block align-top"
                                alt="Aba logo"
                        />
                    </Link>
                    </Col>
                    <Col md={4} style={{height: '30px', width:'60px', marginTop: '40px', color:'white'}} className="d-none d-lg-block"><h5>@ginperegrino.ar</h5> </Col>
                </Row>

            </Row>
            <hr style={{color: 'white'}}></hr>
            <Row>
                <Col xs={12} md={12} style={block3}>
                    <h2 style={{fontStyle:'italic', color:'#DEB97F'}}>{t('peregrinoFrase1')}</h2>
                    <h3>{t('peregrinoFrase2')}</h3>
                </Col>
                <Col md={1}></Col>
                <Col style={block3} md={10}>
                    <Tabs
                        defaultActiveKey="home"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                    >
                        <Tab eventKey="home" title="Golden">
                            <Row>
                                <Col md={6} xs={6} style={block2}>
                                    <img
                                        src={goldenGin}
                                        width="100%"
                                        height="100%"
                                        className="d-inline-block align-top"
                                        alt="Aba logo"
                                    />
                                </Col>
                                <Col md={6} xs={6} style={block2} className="d-none d-lg-block">
                                    <Card style={{ width: '100%', height: '100%', backgroundColor: '#E7DEA7', marginTop: '30px'}}>
                                        <Card.Body style={blockCard}>
                                            <Card.Title style={{fontSize: '3rem', color: '#000000'}}>
                                                <img
                                                    src={tipografiaGolden}
                                                    width="100%"
                                                    height="100%"
                                                    className="d-inline-block align-top"
                                                    alt="Aba logo"
                                                />
                                            </Card.Title>
                                            <Card.Subtitle className="mb-2 text-muted" style={{fontSize: '2rem', marginTop: '30px'}}>{t('peregrinoGoldenTitle')}</Card.Subtitle>
                                            <Card.Text style={textsEscritorio}>
                                                <p>{t('peregrinoGoldenText')}</p>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                {/* Version Mobile */}
                                <Col md={6} xs={6} style={block2} className="d-md-none">
                                    <Card style={{ width: '100%', height: '100%', backgroundColor: '#E7DEA7',marginTop: '30px'}}>
                                        <Card.Body>
                                            <Card.Title>Golden</Card.Title>
                                            <Card.Subtitle className="mb-2 text-muted">{t('peregrinoGoldenTitle')}</Card.Subtitle>
                                            <Card.Text style={textsGolden}>
                                            <p>
                                                {t('peregrinoGoldenText')}
                                            </p>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Tab>
                        <Tab eventKey="profile" title="Pink">
                            <Row>
                            <Col md={6} xs={6} style={blockPink}>
                                    <img
                                        src={pinkGin1}
                                        width="100%"
                                        height="100%"
                                        className="d-inline-block align-top"
                                        alt="Aba logo"
                                    />
                                </Col>
                                <Col md={6} xs={6} style={block2} className="d-none d-lg-block">
                                    <Card style={{ width: '100%', height: '100%', backgroundColor: '#623037',marginTop: '30px', color: 'white'}}>
                                        <Card.Body style={blockCardPink}>
                                            <Card.Title style={{fontSize: '3rem'}}>
                                                <img
                                                    src={tipografiaPink}
                                                    width="100%"
                                                    height="100%"
                                                    className="d-inline-block align-top"
                                                    alt="Aba logo"
                                                />
                                            </Card.Title>
                                            <Card.Subtitle className="mb-2" style={{fontSize: '1.4rem', marginTop: '30px'}}>
                                            {t('peregrinoPinkTitle')}
                                            </Card.Subtitle>
                                            <Card.Text style={textsEscritorioPink}>
                                                <p>
                                                {t('peregrinoPinkText')}
                                                </p>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                {/* Version Mobile */}
                                <Col md={6} xs={6} style={blockPink} className="d-md-none">
                                    <Card style={{ width: '100%', height: '100%', backgroundColor: '#623037',marginTop: '30px',  color: 'white'}}>
                                        <Card.Body>
                                            <Card.Title>Pink</Card.Title>
                                            <Card.Subtitle className="mb-2">{t('peregrinoPinkTitle')}</Card.Subtitle>
                                            <Card.Text style={textsPink}>
                                                <p>
                                                    {t('peregrinoPinkText')}
                                                </p>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Tab>
                        <Tab eventKey="contact" title="Black">
                            <Row>
                            <Col md={6} xs={6} style={blockBlack}>
                                    <img
                                        src={blackGin1}
                                        width="100%"
                                        height="100%"
                                        className="d-inline-block align-top"
                                        alt="Aba logo"
                                    />
                                </Col>
                                <Col md={6} xs={6} style={blockCardBlackMobile} className="d-none d-lg-block">
                                    <Card style={{ width: '100%', height: '100%', backgroundColor: 'white', marginTop: '30px', color: 'white'}}>
                                        <Card.Body style={blockCardBlack}>
                                            <Card.Title style={{fontSize: '3rem'}}>
                                                <img
                                                    src={tipografiaBlack}
                                                    width="100%"
                                                    height="100%"
                                                    className="d-inline-block align-top"
                                                    alt="Aba logo"
                                                />
                                            </Card.Title>
                                            <Card.Subtitle className="mb-2" style={{fontSize: '1.4rem', marginTop: '30px'}}>{t('peregrinoBlackTitle')}</Card.Subtitle>
                                            <Card.Text style={textsEscritorioBlack}>
                                                <p>
                                                    {t('peregrinoBlackText')}
                                                </p>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                {/* Version Mobile */}
                                <Col md={6} xs={6} style={blockCardBlackMobile} className="d-md-none">
                                    <Card style={{ width: '100%', height: '100%', backgroundColor: 'black',marginTop: '30px', color: 'white'}}>
                                        <Card.Body>
                                            <Card.Title>Black</Card.Title>
                                            <Card.Subtitle className="mb-2">{t('peregrinoBlackTitle')}</Card.Subtitle>
                                            <Card.Text style={textsBlack}>
                                            <p>
                                                {t('peregrinoBlackText')}
                                            </p>
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
            <Row style={{marginTop: '40px'}}>
                 <Col md={1} xs={1}></Col>
                 <Col style={{marginTop: '50px',  borderRadius: '30px'}} md={5} xs={12}>
                    <img
                        src={botanicos}
                        width="100%"
                        height="100%"
                        className="d-inline-block align-top"
                        alt="Aba logo"
                        style={{borderRadius: '30px'}}
                    />
                </Col>
                <Col style={{marginTop: '50px', fontSize:'2.5rem',  alignContent: 'center', borderRadius: '10px', textAlign: 'justify'}} md={5} xs={5} className="d-none d-lg-block"><p style={{backgroundColor: '#E7DEA7', borderRadius:'30px',padding:'15px'}}>{t('peregrinoSection1')}</p></Col>
                {/* Version Mobile */}
                <Col style={{marginTop: '10px', fontSize:'15px', alignContent: 'center', borderRadius: '10px', textAlign: 'justify'}} md={5} xs={12} className="d-md-none"><p style={{backgroundColor: '#E7DEA7',borderRadius:'30px',padding:'15px'}}>{t('peregrinoSection1')}</p></Col>
            </Row>
            <Row style={{marginTop: '30px'}}>
                <Col md={1} xs={1}></Col>
                <Col style={block4}  md={5} xs={5} className="d-none d-lg-block"><p style={{fontSize:'2.5rem',  backgroundColor: '#E7DEA7',borderRadius:'30px',padding:'15px',color:'black'}}>{t('peregrinoSection2')}</p></Col>
                <Col style={block4} md={5} xs={6} className="d-none d-lg-block">
                    <ReactPlayer 
                        url={videoFabrica} 
                        controls={true}
                        width='100%'
                        height='800px'
                        loop={true}
                    ></ReactPlayer> 
                </Col>
                {/* Version Mobile */}
                <Col style={block4} md={5} xs={12} className="d-md-none">
                    <ReactPlayer 
                        url={videoFabrica} 
                        controls={true}
                        width='100%'
                        height='800px'
                        loop={true}
                    ></ReactPlayer> 
                </Col>
                <Col style={{fontSize: '15px', alignContent: 'center', color:'white', marginTop: '15px'}}  md={5} xs={12} className="d-md-none">{t('peregrinoSection2')}</Col>
            </Row>
            <hr/>
            <Row id="pruebas">
                <Col md={1} xs={1}></Col>
                <Col xs={12} md={10} style={block5}>
                    <h3>{t('peregrinoSection3Title')}</h3>
                    <p>FALTARIA TEXTO</p>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col md={1} xs={1}></Col>
                <Col xs={12} md={10} style={block5}>
                    <h3>{t('peregrinoSection4Title')}</h3>
                    <p>FALTARIA TEXTO</p>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col md={1} xs={1}></Col>
                <Col xs={12} md={10} style={block5}>
                    <h3>{t('peregrinoMoments')}</h3>
                </Col>
            </Row>
            <Row xs={12} md={12}>
                        <Col xs={12} md={4} style={{ marginBottom: '20px'}}>
                            <img
                            src={sunset8}
                            width="100%"
                            height="100%"
                            className="d-inline-block align-top"
                            alt="Pais"
                            style={{borderRadius: '30px'}}
                            />
                        </Col>
                        <Col xs={12} md={4} style={{ marginBottom: '20px'}}>
                            <img
                            src={sunset7}
                            width="100%"
                            height="100%"
                            className="d-inline-block align-top"
                            alt="Pais"
                            style={{borderRadius: '30px'}}
                            />
                        </Col>
                        <Col xs={12} md={4} style={{ marginBottom: '20px'}}>
                            <img
                            src={sunset6}
                            width="100%"
                            height="100%"
                            className="d-inline-block align-top"
                            alt="Pais"
                            style={{borderRadius: '30px'}}
                            />
                        </Col>
            </Row>
            <hr/>
            <Row>
                <Col md={1} xs={1}></Col>
                <Col xs={12} md={10} style={{ color: 'white', textAlign: 'center'}}><h2>{t('cocktails')}</h2></Col>
            </Row>
            <Row style={{ textAlign: 'center', padding: '5px', marginTop: '5px'}}>  
                <Col xs={12} md={4}>
                <Card style={{ width: '100%'}}>
                    <Card.Img variant="top" src={ginTonic} />
                    <Card.Body>
                        <Card.Title>{t('GinTonic')}</Card.Title>
                            <Card.Text>
                                {t('ingredientsGinTonic')}
                            </Card.Text>
                            {/* <Button variant="primary" onClick={handleShowCoctail1} >Receta Completa</Button> */}
                    </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={4} style={{ marginTop: '5px' }}>
                    <Card style={{ width: '100%', height: '100%'}}>
                    <Card.Img variant="top" src={ginFizz}  style={{height: '100%'} }/>
                    <Card.Body>
                        <Card.Title>{t('ginFizz')}</Card.Title>
                            <Card.Text>
                                {t('ingredientsGinFizz')}
                            </Card.Text>
                            {/* <Button variant="primary" onClick={handleShowCoctail2} >Receta Completa</Button> */}
                    </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} md={4} style={{ marginTop: '5px' }}>
                    <Card style={{ width: '100%'}}>
                    <Card.Img variant="top" src={lemonGin} />
                    <Card.Body>
                        <Card.Title>{t('lemonGin')}</Card.Title>
                            <Card.Text>
                            {t('ingredientsLemonGin')}
                            </Card.Text>
                            {/* <Button variant="primary" onClick={handleShowCoctail2} >Receta Completa</Button> */}
                    </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default MainPeregrino;